




























































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { Route, NavigationGuardNext } from 'vue-router';
import { ValidationObserver } from 'vee-validate';
import Datepicker from 'vuejs-datepicker';
import DatepickerZh from 'vuejs-datepicker/dist/locale/translations/zh';
import Draggable from 'vuedraggable';
import {
  format as formatDate,
  parse as parseDate,
} from 'date-fns';
import { uniq } from 'lodash';
import { ProjectTypes } from '@/configs/project';
import {
  postProjectDetail,
  getProjectDetail,
  postPhoto,
  deletePhoto,
} from '@/configs/api-path';
import { AlbumDetail } from '@/models/album';
import { PhotoUpload } from '@/models/photo';
import { ProjectForm } from '@/models/project';
import ApiStatusMixin from '@/mixins/api-status';
import ApiErrorMixin from '@/mixins/api-error';
import FormWizard from '@/components/piaf/Wizard/FormWizard.vue';
import FormWizardTab from '@/components/piaf/Wizard/Tab.vue';
import InputFile from '@/components/InputFile.vue';
import ImageUploader from '@/components/ImageUploader3.vue';
import FeatureEditor from '@/components/FeatureEditor.vue';
import SingleImageUploader from '@/components/SingleImageUploader.vue';
import { generateId } from '@/utils/string';
import sleep from '@/utils/sleep';

Component.registerHooks([
  'beforeRouteLeave',
]);

const DEFAULT_PROJECT_FORM: ProjectForm = {
  id: null,
  name: '',
  thumbnail_name: null,
  thumbnail_path: null,
  large_photo_name: null,
  large_photo_path: null,
  small_photo_name: null,
  small_photo_path: null,
  urban: false,
  top: false,
  spotlight: false,
  slogan: null,
  home_page_title: null,
  home_page_content: null,
  album: [],
  info_title: null,
  info_content: null,
  base_location: null,
  base_map: null,
  base_size: null,
  completion_year: null,
  floor: null,
  households_number: null,
  agency_address: null,
  agency_map: null,
  agency_mobile: null,
  main_photo: null,
  main_photo_name: null,
  main_photo_path: null,
  feature_list: null,
  intro_title: null,
  intro_content: null,
  intro_album: [],
  intro_plan_title: null,
  intro_plan_content: null,
  intro_plan_album: [],
  intro_env_title: null,
  intro_env_content: null,
  intro_env_album: [],
  thumbnail: null,
  large_photo: null,
  small_photo: null,
};

@Component({
  components: {
    FormWizard,
    FormWizardTab,
    InputFile,
    ImageUploader,
    FeatureEditor,
    SingleImageUploader,
    Datepicker,
    Draggable,
  },
})
export default class PageProjectEdit extends mixins(ApiStatusMixin, ApiErrorMixin) {
  $refs!: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    wizard: any;
    validateObsStep1: InstanceType<typeof ValidationObserver>;
    validateObsStep2: InstanceType<typeof ValidationObserver>;
    validateObsStep3: InstanceType<typeof ValidationObserver>;
    selectMainPhotoFormObs: InstanceType<typeof ValidationObserver>;
    introAlbumSelectFormObs: InstanceType<typeof ValidationObserver>;
    thumbnailUploader: InstanceType<typeof SingleImageUploader>;
    largePhotoUploader: InstanceType<typeof SingleImageUploader>;
    smallPhotoUploader: InstanceType<typeof SingleImageUploader>;
    albumFileInput: InstanceType<typeof InputFile>;
  };

  postPhoto = postPhoto;

  datepickerLang = DatepickerZh;

  projectForm: ProjectForm = { ...DEFAULT_PROJECT_FORM };

  albumForm: {
    id: number | string;
    file: File;
  }[] = [];

  dataFetched = false;

  selectedMainPhoto: number | null = null;

  currentIntroAlbumType: string | null = null;

  introAlbumSelected: AlbumDetail[] = [];

  get currentTab() {
    return this.$refs.wizard.currentActive;
  }

  get breadcrumb() {
    return [
      {
        text: '建案管理',
        to: null,
      },
      {
        text: this.isOutdatedProject ? '舊建案' : '新建案',
        to: null,
      },
      {
        text: this.projectName === '' ? '編輯建案' : this.projectName,
        to: null,
      },
    ];
  }

  get projectType() {
    return this.$route.meta.projectType;
  }

  get isLastestProject() {
    return this.projectType === ProjectTypes.LASTEST;
  }

  get isOutdatedProject() {
    return this.projectType === ProjectTypes.OUTDATED;
  }

  // eslint-disable-next-line class-methods-use-this
  get thumbnailCardClass() {
    return 'card-body align-self-center d-flex flex-column flex-lg-row justify-content-between min-width-zero align-items-lg-center';
  }

  get projectId() {
    return this.$route.params.projectId;
  }

  get projectName() {
    return this.projectForm.name;
  }

  get isSpotlight() {
    return this.projectForm.spotlight;
  }

  get featureList() {
    return this.projectForm.feature_list?.split(',') || [];
  }

  get projectAlbum() {
    return this.projectForm.album;
  }

  get projectAlbumLength() {
    return this.projectAlbum.length;
  }

  get completionYear() {
    return formatDate(this.projectForm.completion_year as Date || new Date(), 'yyyy');
  }

  set completionYear(value: string) {
    this.projectForm.completion_year = value ? parseDate(value, 'yyyy', new Date()) : null;
  }

  get thumbnailPhoto() {
    return {
      file: this.projectForm.thumbnail,
      previewPath: this.projectForm.thumbnail_path,
      previewFilename: this.projectForm.thumbnail_name,
    };
  }

  set thumbnailPhoto(value) {
    this.projectForm.thumbnail = value.file;
    this.projectForm.thumbnail_path = value.previewPath;
    this.projectForm.thumbnail_name = value.previewFilename;
  }

  get hasUploadedThumbnail() {
    return Boolean(this.projectForm.thumbnail_path);
  }

  get largePhoto() {
    return {
      file: this.projectForm.large_photo,
      previewPath: this.projectForm.large_photo_path,
      previewFilename: this.projectForm.large_photo_name,
    };
  }

  set largePhoto(value) {
    this.projectForm.large_photo = value.file;
    this.projectForm.large_photo_path = value.previewPath;
    this.projectForm.large_photo_name = value.previewFilename;
  }

  get hasUploadedLargePhoto() {
    return Boolean(this.projectForm.large_photo_path);
  }

  get smallPhoto() {
    return {
      file: this.projectForm.small_photo,
      previewPath: this.projectForm.small_photo_path,
      previewFilename: this.projectForm.small_photo_name,
    };
  }

  set smallPhoto(value) {
    this.projectForm.small_photo = value.file;
    this.projectForm.small_photo_path = value.previewPath;
    this.projectForm.small_photo_name = value.previewFilename;
  }

  get hasUploadedSmallPhoto() {
    return Boolean(this.projectForm.small_photo_path);
  }

  get usedAlbumPhotos() {
    return uniq([this.projectForm.main_photo_path].concat(
      this.projectForm.intro_album
        ? this.projectForm.intro_album.map((p) => p.path)
        : [],
      this.projectForm.intro_plan_album
        ? this.projectForm.intro_plan_album.map((p) => p.path)
        : [],
      this.projectForm.intro_env_album
        ? this.projectForm.intro_env_album.map((p) => p.path)
        : [],
    ));
  }

  isPhotoSelected(path: string) {
    return this.usedAlbumPhotos.includes(path);
  }

  onAlbumInput(files: File[]) {
    files.forEach((file) => {
      this.albumForm.push({
        id: generateId(6),
        file,
      });
    });

    setTimeout(() => {
      this.$refs.albumFileInput.reset();
    });
  }

  onAlbumUploaded(album: {
    id: string;
    file: File;
    photo: PhotoUpload;
  }) {
    this.projectForm.album.unshift({
      id: album.photo.id,
      name: album.photo.photo_name,
      path: album.photo.path,
      updated_at: album.photo.updated_at,
      status: false,
    });

    this.onAlbumQueueDelete(album.id);
  }

  onAlbumQueueDelete(id: string) {
    const imageIndex = this.albumForm.findIndex(
      (item) => item.id === id,
    );
    this.albumForm.splice(imageIndex, 1);
  }

  async deleteAlbumItem(album: AlbumDetail) {
    if (!album.id) {
      return;
    }

    const confirm = window.confirm('確認刪除此照片？');

    if (confirm === false) {
      return;
    }

    try {
      const { data: deleteAlbumResponse } = await this.$axios.delete<{
        code: number;
        photo: {
          id: number;
        };
      }>(deletePhoto(album.id));

      if (deleteAlbumResponse.code === 0) {
        const itemIndex = this.projectAlbum.findIndex(
          (photo) => photo.id === album.id,
        );
        this.$notify.show(
          'success filled',
          `相簿照片 ${album.name} 已刪除！`,
          '編輯建案',
          { duration: 3000, permanent: false },
        );

        if (itemIndex !== -1) {
          this.projectAlbum.splice(itemIndex, 1);
        }
      } else {
        this.apiErrorCodeAlert(deleteAlbumResponse.code, '編輯建案');
      }
    } catch (error) {
      console.error(error);
    }
  }

  // eslint-disable-next-line class-methods-use-this
  scrollFirstErroField(validateObs: InstanceType<typeof ValidationObserver>) {
    setTimeout(() => {
      const errorField = Object.keys(validateObs.errors)
        .find((key) => validateObs.errors[key].length > 0);

      if (!errorField) {
        return;
      }

      const refPosition = validateObs.refs[errorField].$el.getBoundingClientRect();

      window.scrollTo({
        top: refPosition.top + window.pageYOffset - Math.max(window.innerHeight * 0.15, 120),
      });
    }, 100);
  }

  /* Modals */
  hideModal(refname: string) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const vmRefs = this.$refs as any;

    if (!vmRefs[refname]) {
      return;
    }

    vmRefs[refname].hide();
    console.log(`hide modal:: ${refname}`);

    if (refname === 'modalnestedinline') {
      vmRefs.modalnested.show();
    }
  }

  onSelectMainPhotoModalShow() {
    this.selectedMainPhoto = this.projectAlbum
      .find((photo) => photo.path === this.projectForm.main_photo_path)?.id || null;
  }

  onSelectMainPhotoModalHide() {
    this.selectedMainPhoto = null;
  }

  onIntroAlbumSelectModalShow() {
    // find album item
    console.log(this.currentIntroAlbumType);
    if (this.currentIntroAlbumType) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const list = (this.projectForm as any)[`${this.currentIntroAlbumType}_album`];
      this.introAlbumSelected = list || [];
    }
  }

  onIntroAlbumSelectModalHide() {
    this.currentIntroAlbumType = null;
    this.introAlbumSelected = [];
  }

  openIntroAlbumSelectModal(type: string) {
    this.currentIntroAlbumType = type;
    this.$root.$emit('bv::show::modal', 'selectAlbumPhoto');
  }

  async selectMainPhotoSubmit(modalName: string) {
    try {
      const validateResult = await this.$refs.selectMainPhotoFormObs.validate();

      if (validateResult === true) {
        const selectPhoto = this.projectAlbum.find((photo) => photo.id === this.selectedMainPhoto);
        if (!selectPhoto) {
          return;
        }

        this.projectForm.main_photo = this.selectedMainPhoto;
        this.projectForm.main_photo_name = selectPhoto?.name;
        this.projectForm.main_photo_path = selectPhoto?.path;

        this.hideModal(modalName);
      }
    } catch (error) {
      console.error(error);
    }
  }

  async selectIntroAlbumSubmit(modalName: string) {
    try {
      const validateResult = await this.$refs.introAlbumSelectFormObs.validate();

      if (validateResult === true) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (this.projectForm as any)[`${this.currentIntroAlbumType}_album`] = this.introAlbumSelected;

        this.hideModal(modalName);
      }
    } catch (error) {
      console.error(error);
    }
  }

  /* Wizard */
  async submitStepDataHandler(step: number, formData: FormData) {
    if (!formData) {
      return false;
    }

    if (!this.projectForm.id) {
      return false;
    }

    this.setApiLoading();
    try {
      const formObs = [
        this.$refs.validateObsStep1
          ? this.$refs.validateObsStep1
          : false,
        this.$refs.validateObsStep2
          ? this.$refs.validateObsStep2
          : false,
        this.$refs.validateObsStep3
          ? this.$refs.validateObsStep3
          : false,
      ];

      const { data: submitResponse } = await this.$axios.post<{
        code: number;
        project: {
          id: number;
        };
      }>(postProjectDetail(this.projectForm.id, step), formData);

      if (submitResponse.code === 0) {
        if (formObs[step - 1] !== false) {
          (formObs[step - 1] as InstanceType<typeof ValidationObserver>).reset();
          await sleep(0.1);
        }
        this.setApiPending();
        return true;
      }

      this.apiErrorCodeAlert(submitResponse.code, '編輯建案', {
        105: '置頂超過限制數量（最多顯示 3 則s）',
        106: '顯示於首頁超過限制數量（最多 10 則）',
      });
      this.setApiPending();
      return false;
    } catch (error) {
      console.error(error);
      this.apiHttpErrorAlert(error.response, '編輯建案');
      this.setApiPending();
      return false;
    }
  }

  async validateStep1() {
    const validateResult = await this.$refs.validateObsStep1.validate();

    if (validateResult === false) {
      this.scrollFirstErroField(this.$refs.validateObsStep1);
    }

    return validateResult;
  }

  submitStep1Handler() {
    const formData = new FormData();
    const info = {
      urban: this.projectForm.urban,
      top: this.projectForm.top,
      spotlight: this.projectForm.spotlight,
      slogan: this.projectForm.slogan,
      completion_year: this.completionYear,
      home_page_title: this.projectForm.home_page_title,
      home_page_content: this.projectForm.home_page_content,
      album: this.projectForm.album.map((album) => album.id),
    };

    formData.append('info', JSON.stringify(info));

    if (this.projectForm.thumbnail) {
      formData.append('thumbnail', this.projectForm.thumbnail);
    }

    if (this.projectForm.large_photo) {
      formData.append('large_photo', this.projectForm.large_photo);
    }

    if (this.projectForm.small_photo) {
      formData.append('small_photo', this.projectForm.small_photo);
    }
    return this.submitStepDataHandler(1, formData);
  }

  async validateStep2() {
    const validateResult = await this.$refs.validateObsStep2.validate();

    if (validateResult === false) {
      this.scrollFirstErroField(this.$refs.validateObsStep2);
    }

    return validateResult;
  }

  submitStep2Handler() {
    const formData = new FormData();
    const info = {
      info_title: this.projectForm.info_title,
      info_content: this.projectForm.info_content,
      base_location: this.projectForm.base_location,
      base_map: this.projectForm.base_map,
      base_size: this.projectForm.base_size,
      // completion_year: this.projectForm.completion_year,
      floor: this.projectForm.floor,
      households_number: this.projectForm.households_number,
      agency_address: this.projectForm.agency_address,
      agency_map: this.projectForm.agency_map,
      agency_mobile: this.projectForm.agency_mobile,
      main_photo: this.projectForm.main_photo,
      feature_list: this.projectForm.feature_list,
    };

    formData.append('info', JSON.stringify(info));

    return this.submitStepDataHandler(2, formData);
  }

  async validateStep3() {
    const validateResult = await this.$refs.validateObsStep3.validate();

    if (validateResult === false) {
      this.scrollFirstErroField(this.$refs.validateObsStep3);
    }

    return validateResult;
  }

  submitStep3Handler() {
    const formData = new FormData();
    const info = {
      intro_title: this.projectForm.intro_title,
      intro_content: this.projectForm.intro_content,
      intro_album: this.projectForm.intro_album.map((p) => p.id),
      intro_plan_title: this.projectForm.intro_plan_title,
      intro_plan_content: this.projectForm.intro_plan_content,
      intro_plan_album: this.projectForm.intro_plan_album.map((p) => p.id),
      intro_env_title: this.projectForm.intro_env_title,
      intro_env_content: this.projectForm.intro_env_content,
      intro_env_album: this.projectForm.intro_env_album.map((p) => p.id),
    };

    formData.append('info', JSON.stringify(info));

    return this.submitStepDataHandler(3, formData);
  }

  // eslint-disable-next-line class-methods-use-this
  onWizardIndexChanged() {
    window.scrollTo({
      top: 0,
    });
  }

  onEditDone() {
    this.$notify.show('success filled', '建案儲存成功！', '編輯建案', { duration: 3000, permanent: false });
    this.$router.push({
      name: 'project-list',
      params: {
        projectType: this.projectType,
      },
    });
  }

  async fetchProjectDetails() {
    if (!this.projectId) {
      this.$router.replace({
        name: 'project-list',
        params: {
          projectType: this.projectType,
        },
      });
      return;
    }

    this.setApiLoading();
    try {
      const { data: fetchResponse } = await this.$axios.get<{
        code: number;
        project: ProjectForm;
      }>(getProjectDetail(this.projectId));

      if (fetchResponse.code === 0) {
        this.projectForm = Object.assign(DEFAULT_PROJECT_FORM, fetchResponse.project);

        this.completionYear = fetchResponse.project.completion_year as string;

        this.dataFetched = true;
        setTimeout(() => {
          const mainPhotoId = this.projectAlbum
            .find((photo) => photo.path === this.projectForm.main_photo_path);

          if (mainPhotoId) {
            this.projectForm.main_photo = mainPhotoId.id;
            this.projectForm.main_photo_name = mainPhotoId.name;
            this.projectForm.main_photo_path = mainPhotoId.path;
          } else {
            this.projectForm.main_photo_name = null;
            this.projectForm.main_photo_path = null;
          }

          if (this.$refs.validateObsStep1) {
            this.$refs.validateObsStep1.reset();
          }

          if (this.$refs.validateObsStep2) {
            this.$refs.validateObsStep2.reset();
          }

          if (this.$refs.validateObsStep3) {
            this.$refs.validateObsStep3.reset();
          }
        }, 0);
      } else {
        this.apiErrorCodeAlert(fetchResponse.code, '編輯建案');
        this.$router.replace({
          name: 'project-list',
          params: {
            projectType: this.projectType,
          },
        });
      }
    } catch (error) {
      console.error(error);
      this.apiHttpErrorAlert(error.response, '編輯建案');
    }
    this.setApiPending();
  }

  goBack() {
    this.$router.push({
      name: 'project-list',
      params: {
        projectType: this.projectType,
      },
    });
  }

  // eslint-disable-next-line class-methods-use-this
  beforeRouteLeave(to: Route, from: Route, next: NavigationGuardNext) {
    const isChangedObs = [
      this.$refs.validateObsStep1
        ? this.$refs.validateObsStep1.flags.changed
        : false,
      this.$refs.validateObsStep2
        ? this.$refs.validateObsStep2.flags.changed
        : false,
      this.$refs.validateObsStep3
        ? this.$refs.validateObsStep3.flags.changed
        : false,
    ];

    if (isChangedObs[this.currentTab]) {
      // eslint-disable-next-line no-alert
      const confirm = window.confirm('確定要離開編輯頁面？\n未儲存的資料將不會保留。');

      if (confirm === false) {
        return;
      }
      next();
      return;
    }
    next();
  }

  beforeDestroy() {
    this.projectForm.thumbnail = null;
    this.projectForm.small_photo = null;
    this.projectForm.large_photo = null;
  }

  beforeMount() {
    this.fetchProjectDetails();
  }
}
